<template>
    <div>
        <app-store-form v-if="!!selectedStore" :myStore="selectedStore" :onSave="onSave" :edit="true" id="store-update" />
        <b-button 
            variant="confirm" 
            :disabled="inProgress" 
            class="btn-block-xs-only"
            @click="$bus.$emit('store-update.save')"><i class="fa fa-floppy-o"></i> Guardar comercio
        </b-button>
    </div>
</template>
<script>
import StoreForm from '../StoreForm/StoreForm';
import {mapGetters, mapMutations} from 'vuex';
import * as mutations from '../../../../store/commitTypes';
export default {
    components: {
        appStoreForm: StoreForm
    },
    props: {
        store: {
            required: true
        }
    },
    computed: {
        ...mapGetters(['selectedStore']),
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        onSave(store) {
            this.setSelectedStore(store);
        }
    },
    created() {
        console.log('ugi created');
    }
}
</script>
